module.exports = __webpack_public_path__ + "static/media/cloudy.0e54e28f.mov";